import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharingDataService {

  private gipDefault = new BehaviorSubject<any>(null);
  currentGipDefault = this.gipDefault.asObservable();

  private resourceDefinition = new BehaviorSubject<any>(null);
  currentResourceDefinition = this.resourceDefinition.asObservable();

  private picklist = new BehaviorSubject<any>(null);
  currentPicklist = this.picklist.asObservable();

  private language = new BehaviorSubject<string>(null);
  currentLanguage = this.language.asObservable();

  private user = new BehaviorSubject<any>(null);
  currentUser = this.user.asObservable();

  private newRequestUploadFiles = new BehaviorSubject<any>(null);
  currentnewRequestUploadFiles = this.newRequestUploadFiles.asObservable();

  private requestUser = new BehaviorSubject<any>(null);
  currentRequestUser = this.requestUser.asObservable();

  private personNotif = new BehaviorSubject<any>(null);
  currentPersonNotif = this.personNotif.asObservable();

  constructor() { }

  changeGipDefault(object){
    this.gipDefault.next(object);
  }

  changeResourceDefinition(object){
    this.resourceDefinition.next(object);
  }

  changePicklist(object){
    this.picklist.next(object);
  }

  changeLanguage(language){
    this.language.next(language);
  }

  changeUser(user){
    this.user.next(user);
  }

  changenewRequestUploadFiles(newRequestUploadFiles){
    this.newRequestUploadFiles.next(newRequestUploadFiles);
  }

  changeCurrentRequestUser(requestUser){
    this.requestUser.next(requestUser);
  }

  changePersonNotif(personNotif){
    this.personNotif.next(personNotif);
  }


}
